import { z } from 'zod'

import type { CustomerSort, CustomerTab } from './queries'

export const TABS: { key: CustomerTab; label: string }[] = [
  { key: 'customers', label: 'Customers' },
  { key: 'follow_ups', label: 'Follow-ups' },
]

const SORTS = [
  'name',
  '-name',
  'evaluation_count',
  '-evaluation_count',
  '-last_evaluated_at,name',
  'last_evaluated_at',
  'follow_up_on',
  '-follow_up_on',
] as const satisfies readonly CustomerSort[]

/** Each tab's order unless a column says otherwise: the last evaluated, or the soonest due. */
export const DEFAULT_SORT: Record<CustomerTab, CustomerSort> = {
  customers: '-last_evaluated_at,name',
  follow_ups: 'follow_up_on',
}

/**
 * The customers list's search: the tab, the search, the sort and the page, in the address.
 * Anything unreadable is dropped rather than refused, which leaves the default.
 */
export const customersSearchSchema = z.object({
  tab: z.enum(['customers', 'follow_ups']).optional().catch(undefined),
  q: z.string().max(100).optional().catch(undefined),
  sort: z.enum(SORTS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
})

export type CustomersSearch = z.output<typeof customersSearchSchema>
